import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-cream/60 py-8 border-t border-white/10" data-id="element-48">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 text-center text-sm" data-id="element-49">
        <p data-id="element-50">
          &copy; {new Date().getFullYear()} Fuerza Post-Parto 21. Todos los
          derechos reservados.
        </p>
        <p className="mt-2 text-xs opacity-70" data-id="element-51">
          Este producto no sustituye el consejo médico profesional. Consulta a
          tu médico antes de iniciar cualquier programa de ejercicios
          post-parto.
        </p>
      </div>
    </footer>;
}